import { z } from "zod"

export const storageProfileSchema = z.object({
  /** Proposal => Site => GenabilityAccountId */
  accountId: z.string(),
  /** null */
  baselineMeasures: z.null(),
  /** 2 */
  dataStatus: z.literal(2),
  /** true */
  isDefault: z.boolean(),
  /** genability generated id */
  profileId: z.string(),
  /** sha1 hash of the readingData key */
  providerProfileId: z.string(),
  /** human readable name for the profile */
  profileName: z.string(),
  /** null */
  properties: z.null(),
  /** ELECTRICITY */
  serviceTypes: z.literal(`ELECTRICITY`),
  /** ReadingEntry */
  source: z.object({
    /** Readings */
    name: z.literal(`Readings`),
    /** ReadingEntry */
    sourceId: z.literal(`ReadingEntry`),
    /** null */
    sourceVersion: z.null(),
    /** Reading */
    type: z.literal(`Reading`),
  }),
})

export type StorageProfile = z.infer<typeof storageProfileSchema>
